/**
 * Gets the tax rate for the given country and state.
 * @param  {string} country
 * @param  {string} state
 * @returns {number}
 */
function getTaxRateShippingUtil (country, state) {
  // TODO update when getting tax
  return 0
  // If the delivery is not in Canada, noop
  // if (!isCanadaCountryUtil(country)) {
  //   return 0
  // }
  // return SHIPPING_TAX_RATE[state] / 100
}

export {
  getTaxRateShippingUtil
}
